module.exports = __webpack_public_path__ + "static/media/HU.70eee4dd.svg";